import { alertConstants } from '../_constants/alert.constants';

export const alertActions = {
  success,
  warning,
  error,
  info,
  clear
}

function warning(message) {
  return { type: alertConstants.WARNING, message };
}

function info(message) {
  return { type: alertConstants.INFO, message };
}

function success(message) {
  return { type: alertConstants.SUCCESS, message };
}

function error(message) {
  return { type: alertConstants.ERROR, message };
}

function clear() {
  return { type: alertConstants.CLEAR };
}